import { createContext } from 'react'

const InputContext = createContext({ })

export default InputContext
